import type { App, Plugin } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createApi, type HttpClient } from '@shopexperts/legacy-api'
import { ApiKey, HttpClientKey } from '../api/symbols'

export interface ApiPluginOptions {
  client: HttpClient,
  baseUrl: string,
  installVueQuery?: boolean,
}

export function createApiPlugin(options: ApiPluginOptions): Plugin {
  // The endpoint tree is stateless (client + baseUrl are fixed per plugin), so
  // build it once and share it across installs — during SSR the plugin is
  // installed on a fresh app per request, and rebuilding ~280 endpoint
  // closures each time is pure allocation churn.
  let api: ReturnType<typeof createApi> | null = null
  return {
    install(app: App) {
      if (options.installVueQuery !== false) {
        app.use(VueQueryPlugin)
      }
      if (!options?.client) throw new Error('ApiPlugin: client is required')
      if (!options?.baseUrl) throw new Error('ApiPlugin: baseUrl is required')
      api ??= createApi(options.client, options.baseUrl)
      app.provide(HttpClientKey, options.client);
      app.provide(ApiKey, api)
    }
  }
}

export const ApiPlugin: Plugin = {
  install(app: App, options?: ApiPluginOptions) {
    if (options?.installVueQuery !== false) {
      app.use(VueQueryPlugin)
    }
    if (!options?.client) throw new Error('ApiPlugin: client is required')
    if (!options?.baseUrl) throw new Error('ApiPlugin: baseUrl is required')
    app.provide(HttpClientKey, options.client);
    app.provide(ApiKey, createApi(options.client, options.baseUrl))
  }
}

export * from '../api/symbols'
export type { HttpClient, RequestOptions, QueryParams, QueryValue } from '@shopexperts/legacy-api'
